type ShapesProps = {
  nodes: any
  materials: any
}

const Shapes = ({ nodes, materials }: ShapesProps) => {
  return (
    <>
      <mesh
        name="extra-shape-1"
        castShadow
        receiveShadow
        geometry={nodes['extra-shape-1'].geometry}
        material={materials['white-flat']}
        position={[-5.521, 0.374, -15.865]}
      />
      <mesh
        name="extra-shape-2"
        castShadow
        receiveShadow
        geometry={nodes['extra-shape-2'].geometry}
        material={materials['white-flat']}
        position={[-12.021, -11.052, -0.959]}
      />
      <mesh
        name="extra-shape-3"
        castShadow
        receiveShadow
        geometry={nodes['extra-shape-3'].geometry}
        material={materials['white-flat']}
        position={[4.135, -25.6, 7.776]}
      />
      <mesh
        name="extra-shape-4"
        castShadow
        receiveShadow
        geometry={nodes['extra-shape-4'].geometry}
        material={materials['white-flat']}
        position={[-4.214, -35.113, -3.658]}
      />
      <mesh
        name="extra-shape-5"
        castShadow
        receiveShadow
        geometry={nodes['extra-shape-5'].geometry}
        material={materials['white-flat']}
        position={[-3.595, -61.982, -3.547]}
      />
      <mesh
        name="extra-shape-6"
        castShadow
        receiveShadow
        geometry={nodes['extra-shape-6'].geometry}
        material={materials['white-flat']}
        position={[-9.762, -68.794, -0.321]}
      />
      <mesh
        name="extra-shape-7"
        castShadow
        receiveShadow
        geometry={nodes['extra-shape-7'].geometry}
        material={materials['white-flat']}
        position={[-1.086, -87.697, 2.387]}
      />
      <mesh
        name="extra-shape-8"
        castShadow
        receiveShadow
        geometry={nodes['extra-shape-8'].geometry}
        material={materials['white-flat']}
        position={[-1.279, -77.101, 2.387]}
      />
      <mesh
        name="extra-shape-9"
        castShadow
        receiveShadow
        geometry={nodes['extra-shape-9'].geometry}
        material={materials['white-flat']}
        position={[2.129, -111.887, -6.941]}
      />
      <mesh
        name="extra-shape-10"
        castShadow
        receiveShadow
        geometry={nodes['extra-shape-10'].geometry}
        material={materials['white-flat']}
        position={[-2.484, -120.582, -0.959]}
      />
      <mesh
        name="extra-shape-11"
        castShadow
        receiveShadow
        geometry={nodes['extra-shape-11'].geometry}
        material={materials['white-flat']}
        position={[3.846, -140.429, 7.776]}
      />
      <mesh
        name="extra-shape-12"
        castShadow
        receiveShadow
        geometry={nodes['extra-shape-12'].geometry}
        material={materials['white-flat']}
        position={[-2.249, -159.424, -3.166]}
      />
      <mesh
        name="extra-shape-13"
        castShadow
        receiveShadow
        geometry={nodes['extra-shape-13'].geometry}
        material={materials['white-flat']}
        position={[-0.223, -173.247, -3.547]}
      />
      <mesh
        name="extra-shape-14"
        castShadow
        receiveShadow
        geometry={nodes['extra-shape-14'].geometry}
        material={materials['white-flat']}
        position={[-0.864, -175.809, 0.639]}
      />
      <mesh
        name="extra-shape-15"
        castShadow
        receiveShadow
        geometry={nodes['extra-shape-15'].geometry}
        material={materials['white-flat']}
        position={[-4.26, -217.043, -0.57]}
      />
      <mesh
        name="extra-shape-16"
        castShadow
        receiveShadow
        geometry={nodes['extra-shape-16'].geometry}
        material={materials['white-flat']}
        position={[1.356, -218.053, -1.672]}
      />
      <mesh
        name="extra-shape-17"
        castShadow
        receiveShadow
        geometry={nodes['extra-shape-17'].geometry}
        material={materials['white-flat']}
        position={[-2.732, -232.587, -0.486]}
      />
      <mesh
        name="extra-shape-18"
        castShadow
        receiveShadow
        geometry={nodes['extra-shape-18'].geometry}
        material={materials['white-flat']}
        position={[-5.388, -277.747, -3.995]}
      />
      <mesh
        name="extra-shape-19"
        castShadow
        receiveShadow
        geometry={nodes['extra-shape-19'].geometry}
        material={materials['white-flat']}
        position={[-2.82, -272.973, 4.74]}
      />
    </>
  )
}

export default Shapes
